import { render, staticRenderFns } from "./ResolutionsList.vue?vue&type=template&id=09f552e6&"
import script from "./ResolutionsList.vue?vue&type=script&lang=js&"
export * from "./ResolutionsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports